<template>
  <div class="content-wrapper intro-collection">
    <div class="d-flex align-items-center full-height justify-content-center">
      <div class="center">
        <div class="uppercase small-text mb-4">The passoni collection</div>
        <div class="mb-5">
          We have 11 models in our collection - seven road bikes, two urban, one
          gravel and one mountain.<br />
          The questionnaire and configuration process enables us to create the
          perfect bike for you.
        </div>
        <div class="bikes-list xl-content mt-4">
          <div
            class="bike"
            v-for="bike in bikes"
            v-bind:key="bike.id"
          >
            <img :src="'/storage/' + bike.small_image" />
            {{ bike.name }}
          </div>
        </div>
        <button
          class="btn btn-outline-primary bottom-button"
          v-on:click="$emit('go-next')"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "intro-collection",
  data() {
    return {};
  },
  props: ['bikes']
};
</script>

